<template>
  <div style="height: 83vh;overflow: hidden auto;">
    <b-row class="p-5">
      <b-col cols="3">
        <b-card title="TOTAL" class="text-center">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="100"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="IN PROGRESS" class="text-center">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="15"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="COMPLETED" class="text-center">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="30"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="NOT STARTED" class="text-center">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="20"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="p-5">
      <b-col cols="12">
          <b-card>
        
        <h6>Select Onboarding Forms :</h6>
      
        <b-form-group class="text-left my-2">
          <v-select
            label="text"
            :options="formsOptions"
            v-model="selectedDDq"
          />
            <!-- @input="onSelectDDq" -->
        </b-form-group>
      
      </b-card>
      </b-col>
      
      
    </b-row>
    <b-row class="p-5">
      <b-col cols="6">
        <b-card>
          <highcharts :options="donotChartOptions" />
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card>
          <highcharts :options="stacked3dChartOptions" />
        </b-card>
      </b-col>
    </b-row>
    <b-row class="p-5">
      <b-col cols="6">
        <b-card>
          <highcharts :options="pie3dChartOptions" />
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card>
          <highcharts :options="donotChartOptions" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "Stats",
  data() {
    return {
      selectedDDq: null,
      formsOptions: [],
      donotChartOptions: {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
          },
        },
        title: {
          text: "Contents of Highsoft's weekly fruit delivery",
        },
        subtitle: {
          text: "3D donut in Highcharts",
        },
        plotOptions: {
          pie: {
            innerSize: 100,
            depth: 45,
          },
        },
        series: [
          {
            name: "Delivered amount",
            data: [
              ["Bananas", 8],
              ["Kiwi", 3],
              ["Mixed nuts", 1],
              ["Oranges", 6],
              ["Apples", 8],
              ["Pears", 4],
              ["Clementines", 4],
              ["Reddish (bag)", 1],
              ["Grapes (bunch)", 1],
            ],
          },
        ],
      },
      stacked3dChartOptions: {
        chart: {
          type: "column",
          options3d: {
            enabled: true,
            alpha: 15,
            beta: 15,
            viewDistance: 25,
            depth: 40,
          },
        },

        title: {
          text: "Total fruit consumption, grouped by gender",
        },

        xAxis: {
          categories: ["Apples", "Oranges", "Pears", "Grapes", "Bananas"],
          labels: {
            skew3d: true,
            style: {
              fontSize: "16px",
            },
          },
        },

        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: "Number of fruits",
            skew3d: true,
          },
        },

        tooltip: {
          headerFormat: "<b>{point.key}</b><br>",
          pointFormat:
            '<span style="color:{series.color}">\u25CF</span> {series.name}: {point.y} / {point.stackTotal}',
        },

        plotOptions: {
          column: {
            stacking: "normal",
            depth: 40,
          },
        },

        series: [
          {
            name: "John",
            data: [5, 3, 4, 7, 2],
            stack: "male",
          },
          {
            name: "Joe",
            data: [3, 4, 4, 2, 5],
            stack: "male",
          },
          {
            name: "Jane",
            data: [2, 5, 6, 2, 1],
            stack: "female",
          },
          {
            name: "Janet",
            data: [3, 0, 4, 4, 3],
            stack: "female",
          },
        ],
      },
      pie3dChartOptions: {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          text: "Browser market shares at a specific website, 2014",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
            },
          },
        },
        series: [
          {
            type: "pie",
            name: "Browser share",
            data: [
              ["Firefox", 45.0],
              ["IE", 26.8],
              {
                name: "Chrome",
                y: 12.8,
                sliced: true,
                selected: true,
              },
              ["Safari", 8.5],
              ["Opera", 6.2],
              ["Others", 0.7],
            ],
          },
        ],
      },
    };
  },
  mounted(){
    this.getOnboardingFormsList();
  },
  methods:{
    async getOnboardingFormsList() {
      this.formsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP("get", "api/v1/onboarding/forms/all-onboarding-forms-list", null);
        this.formsOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
  }
};
</script>